import React, { useState, useEffect, useContext } from 'react';
import './header.css';
import companyLogo from '../../assets/images/home/logo.svg';
import Bars from '../../assets/images/home/bars.svg';
import Close from '../../assets/images/home/close.svg';
// import Expand from "../../assets/images/header/expandMore.svg";
import Expand from '../../assets/images/header/menuIcon.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import WiseDriveLogoNew from '../../assets/images/header/wiseDrivelogoNew.png';
import wiseDrivelogoFooter from '../../assets/images/footer/wiseDrivelogoBlueFooter.png';

import FairCarLogo from '../../assets/images/header/FairCarLogo.png';
import { MyContext } from '../../context';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import axios from 'axios';
import { SendIpOnHomeLoad } from '../../Api/PortalApis';
import { FormControl, MenuItem, Select } from '@mui/material';
import { IndiaContent } from '../../assets/content/indiaContent.js';
import { IndonesiaContent } from '../../assets/content/indonesiaContent.js';
import { MalaysiaContent } from '../../assets/content/malaysiaContent.js';
import { ThailandContent } from '../../assets/content/thailandContent.js';
import {
  EnglishMyContent,
  EnglishThContent,
} from '../../assets/content/englishContent.js';
import { set } from 'lodash';

const Header = () => {
  const navigate = useNavigate();
  const path = window.location.href.split('/')[3];
  const [active, setActive] = useState('');
  const [headerDropDownText, setHeaderDropDownText] = useState('');
  const [visible, setVisible] = useState(true);
  const [openKycPopup, setOpenKycPopup] = useState(false);
  const {
    pageData,
    setOwnerPlanTabActive,
    country,
    countries,
    setCountry,
    setPageData,
    setLanguage,
    language,
  } = useContext(MyContext);

  const [carNumber, setCarNumber] = useState('');
  const [disableButton, setDisableButton] = useState(true);

  const handleChangeCountry = async (event) => {
    setCountry(event.target.value);
    if (event.target?.value == 'in') {
      navigate('/in');
      setLanguage(event.target?.value);
      setPageData(IndiaContent);
    } else if (event.target?.value == 'id') {
      navigate('/id');
      setLanguage(event.target?.value);
      setPageData(IndonesiaContent);
    } else if (event.target?.value == 'my') {
      navigate('/my');
      setLanguage(event.target?.value);
      setPageData(MalaysiaContent);
    } else if (event.target?.value == 'th') {
      navigate('/th');
      setLanguage(event.target?.value);
      setPageData(ThailandContent);
    } else navigate('/cs');
  };
  useEffect(() => {
    if (country == '/cs') {
      navigate('/cs');
    }
  }, []);

  async function sendIpOnLoad() {
    try {
      // get ip address from the ipfy api
      const res = await axios.get('https://api.ipify.org/?format=json');

      if (res.status === 200) {
        const userIp = res.data.ip;

        const data = {
          ip: userIp,
        };
        try {
          const resp = await SendIpOnHomeLoad(data);
          if (resp.status === 200) {
          }
        } catch (error) {
          console.error('Sending ip address failed', error);
        }
      } else {
        throw new Error('Failed to get ip address from the ipfy api');
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    sessionStorage.clear();
  }, []);
  useEffect(() => {
    const handleScroll = () => {};
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const cls = visible ? '' : 'hidden';

  const [isOpen, setIsOpen] = useState(false);

  const openNav = () => {
    setIsOpen(!isOpen);

    // document.addEventListener("click", handleDocumentClick);
  };

  const closeNav = () => {
    setIsOpen(false);
    document.getElementById('myNav').style.height = '0%';
    // document.removeEventListener("click", handleDocumentClick);
  };

  const closeKycPopup = () => {
    setOpenKycPopup(false);
  };

  useEffect(() => {
    ShowHeaderDropdown();
  }, [path]);

  const ShowHeaderDropdown = () => {
    if (path === 'buyer') {
      setHeaderDropDownText('Buyer');
    } else if (path === 'owner') {
      setHeaderDropDownText('Owner');
    } else {
      setHeaderDropDownText('Owner');
    }
  };

  const ExplorePlansSwitchTabs = () => {
    if (path === 'buyer') {
      setOwnerPlanTabActive(1);
    } else if (path === 'owner') {
      setOwnerPlanTabActive(0);
    } else {
      setOwnerPlanTabActive(0);
    }

    navigate('/owner-pricing-plans');
    setActive('');
  };

  const handleCarNumber = (e) => {
    setCarNumber(e.target.value);
    if (e.target.value.length >= 6) {
      setDisableButton(false);
    } else if (e.target.value.length < 6) setDisableButton(true);
  };

  const fixBackground = () => {
    document.body.style.overflow = openKycPopup ? 'auto' : 'hidden';
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementsByTagName('header')[0];

      if (window.pageYOffset <= 10) {
        // header.style.backgroundColor = '#000';
      } else {
        header.style.backgroundColor = '#fff';
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    if (event.target.value == 'en' && country == 'my') {
      setPageData(EnglishMyContent);
    } else {
      if (country == 'in') {
        setPageData(IndiaContent);
      } else if (country == 'id') {
        setPageData(IndonesiaContent);
      } else if (country == 'my') {
        setPageData(MalaysiaContent);
      } else if (country == 'th') {
        setPageData(ThailandContent);
      }
    }
  };

  return (
    <header>
      <div className="container">
        <div className="logo">
          {path === 'car_general_service' || path === 'submission_success' ? (
            // <img src={wisedDrivelogo} alt="company logo" className="company-logo" />
            <img
              loading="lazy"
              src={wiseDrivelogoFooter}
              alt="company logo"
              className="company-logo"
            />
          ) : (
            <Link to="/">
              <img
                loading="lazy"
                src={wiseDrivelogoFooter}
                alt="company logo"
                className="company-logo"
              />
            </Link>
          )}

          <div className="menuLinkAndOwner">
            <div className="mobile">
              <FormControl fullWidth>
                <Select
                  value={country}
                  label="Age"
                  onChange={handleChangeCountry}
                  sx={{
                    '& .MuiSelect-select': {
                      border: '1px solid  #003cc5',
                      padding: '0px 5px 0px 5px',
                      fontSize: '16px',
                      paddingRight: '5px !important', // Override default padding
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color on hover
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color when focused
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: 'black',
                      fontSize: '14px',
                    },
                    '& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root':
                      {
                        width: '95px',
                        paddingRight: '0px !important',
                      },
                    '& .MuiSelect-icon': {
                      display: 'none !important',
                    },
                  }}
                >
                  {countries?.map((country) => (
                    <MenuItem
                      value={country?.value}
                      key={country?.value}
                      disabled={country?.disabled}
                    >
                      <div className="country-dropdown-item">
                        {country?.name}
                        <img
                          loading="lazy"
                          src={country.flagImage}
                          alt="country flag"
                          className="flagImg"
                        ></img>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>

        <div className="navLinks">
          <ul>
            <li className="headerDropdownList"></li>
            {pageData?.headerPage?.menuItems}
            <li>
              <FormControl fullWidth>
                <Select
                  value={country == 'googleadsleadgen' ? 'in' : country}
                  onChange={handleChangeCountry}
                  sx={{
                    '& .MuiSelect-select': {
                      border: '1px solid  #003cc5',
                      padding: '4px 5px 4px 5px',
                      fontSize: '16px',
                      paddingRight: '5px !important', // Override default padding
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color on hover
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color when focused
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: 'black',
                      fontSize: '14px',
                    },
                    '& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root':
                      {
                        width: '95px',
                        paddingRight: '0px !important',
                      },
                    '& .MuiSelect-icon': {
                      display: 'none !important',
                    },
                  }}
                >
                  {countries?.map((country) => (
                    <MenuItem
                      value={country?.value}
                      key={country?.value}
                      disabled={country?.disabled}
                    >
                      <div className="country-dropdown-item">
                        {country?.name}
                        <img
                          loading="lazy"
                          src={country.flagImage}
                          style={{ padding: '5px' }}
                          className="flagImg"
                          alt=""
                        ></img>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </li>
            {pageData?.headerPage?.languages?.length > 0 && (
              <li>
                <Select
                  value={language}
                  onChange={handleLanguageChange}
                  sx={{
                    '& .MuiSelect-select': {
                      border: '1px solid  #003cc5',
                      padding: '3px',
                      fontSize: '16px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color on hover
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#0c286a', // Border color when focused
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: 'black',
                      fontSize: '14px',
                    },
                    '& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root':
                      {
                        width: '95px',
                        paddingRight: '0px !important',
                      },
                  }}
                >
                  {pageData?.headerPage?.languages?.map((language) => (
                    <MenuItem key={language.id} value={language.id}>
                      <div className="country-dropdown-item">
                        {language.label}
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </li>
            )}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
